import { NgModule } from '@angular/core';
import { ThrottleClickDirective } from './directives/throttle-click/throttle-click.directive';

@NgModule({
  declarations: [ThrottleClickDirective],
  exports: [ThrottleClickDirective]
})
export class SharedDirectivesModule {}
